import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _div;
import { clsx } from 'clsx';
import { DEFAULT_DISTANCE_FROM_CONTAINER } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
var positionClasses = {
  top: 'tw-rotate-180',
  bottom: '-tw-bottom-2',
  left: 'tw-rotate-90',
  right: '-tw-rotate-90'
};
var Triangle = function Triangle(_ref) {
  var tooltipPosition = _ref.tooltipPosition,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? DEFAULT_DISTANCE_FROM_CONTAINER : _ref$offset;
  var adaptedIdealPositionWithOffset = tooltipPosition === 'top' || tooltipPosition === 'bottom' ? offset * -1 : (offset + 2) * -1;
  var style = _defineProperty({}, tooltipPosition, adaptedIdealPositionWithOffset);
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-absolute tw-w-1.2 tw-overflow-hidden tw-inline-block', positionClasses[tooltipPosition]),
    style: style,
    children: _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-h-0.8 tw-w-0.8 tw-bg-neutral-dark-700 dark:tw-bg-neutral-light-200 tw-rotate-45 tw-transform tw-origin-bottom-left"
    }))
  });
};
export default Triangle;